import type { SVGProps } from 'react';

/**
 * ICÔNES — dessinées à la main, une seule épaisseur de trait.
 * Aucun jeu d'icônes chargé depuis un CDN : le site doit tenir hors ligne, et
 * une seule famille graphique évite le patchwork qui faisait « catalogue ».
 */
const TRACES = {
  search: <><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4.5 4.5" /></>,
  cart: <><path d="M3 4h2.2l2.2 10.2h10.8L21 7H6" /><circle cx="9.5" cy="19" r="1.3" /><circle cx="17" cy="19" r="1.3" /></>,
  user: <><circle cx="12" cy="8.5" r="3.6" /><path d="M5 20c.7-3.4 3.6-5.4 7-5.4s6.3 2 7 5.4" /></>,
  menu: <><path d="M4 7h16M4 12h16M4 17h10" /></>,
  close: <><path d="m6 6 12 12M18 6 6 18" /></>,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  chevronRight: <path d="m9 6 6 6-6 6" />,
  chevronLeft: <path d="m15 6-6 6 6 6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  truck: <><path d="M2.5 6.5h11v9h-11z" /><path d="M13.5 10h4l3 3v2.5h-7z" /><circle cx="6.5" cy="17.5" r="1.6" /><circle cx="17" cy="17.5" r="1.6" /></>,
  store: <><path d="M3.5 9.5V19h17V9.5" /><path d="M2.5 9.5 4.7 4.5h14.6l2.2 5a3 3 0 0 1-5.4 1 3 3 0 0 1-5 0 3 3 0 0 1-5 0 3 3 0 0 1-3.6-1z" /><path d="M9.5 19v-5h5v5" /></>,
  phone: <path d="M6.5 3.5h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2Z" />,
  star: <path d="m12 3.6 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.8l5.9-.8z" />,
  arrowRight: <><path d="M4 12h15" /><path d="m13 6 6 6-6 6" /></>,
  arrowUp: <><path d="M12 19V5" /><path d="m6 11 6-6 6 6" /></>,
  arrowUpRight: <><path d="M7 17 17 7" /><path d="M8 7h9v9" /></>,
  filter: <><path d="M4 6h16M7 12h10M10 18h4" /></>,
  grid: <><rect x="3.5" y="3.5" width="7" height="7" rx="1.6" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.6" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.6" /><rect x="13.5" y="13.5" width="7" height="7" rx="1.6" /></>,
  list: <><path d="M9 6.5h11M9 12h11M9 17.5h11" /><circle cx="4.6" cy="6.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="4.6" cy="12" r="1.2" fill="currentColor" stroke="none" /><circle cx="4.6" cy="17.5" r="1.2" fill="currentColor" stroke="none" /></>,
  info: <><circle cx="12" cy="12" r="8.5" /><path d="M12 11v5" /><circle cx="12" cy="8" r=".9" fill="currentColor" stroke="none" /></>,
  shield: <><path d="M12 3.5 5 6v6c0 4 3 7 7 8.5 4-1.5 7-4.5 7-8.5V6z" /><path d="m9 12 2.2 2.2L15.5 10" /></>,
  snow: <><path d="M12 3v18M4.2 7.5l15.6 9M19.8 7.5 4.2 16.5" /><path d="m9.5 4.5 2.5 2 2.5-2M9.5 19.5l2.5-2 2.5 2" /></>,
  scale: <><path d="M12 4v16M7 20h10" /><path d="M4 8h16" /><path d="M4 8l-2.2 5a2.6 2.6 0 0 0 4.4 0z" /><path d="M20 8l2.2 5a2.6 2.6 0 0 1-4.4 0z" /></>,
  clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  pin: <><path d="M12 21s6.5-6 6.5-11a6.5 6.5 0 1 0-13 0C5.5 15 12 21 12 21Z" /><circle cx="12" cy="10" r="2.4" /></>,
  leaf: <><path d="M20 4C10 4 5 8 5 14a5 5 0 0 0 5 5c6 0 10-5 10-15Z" /><path d="M4 21c2-5 6-9 12-12" /></>,
  flame: <path d="M12 3s5 4.5 5 9a5 5 0 0 1-10 0c0-2 1-3.5 2-4.5 0 2 1 3.2 2 3.2 1.4 0 2-1.6 1-7.7Z" />,
  heart: <path d="M12 20s-7.5-4.4-7.5-9.4A4.1 4.1 0 0 1 12 7.8a4.1 4.1 0 0 1 7.5 2.8C19.5 15.6 12 20 12 20Z" />,
  home: <><path d="m3.5 10.5 8.5-7 8.5 7" /><path d="M6 9.5V20h12V9.5" /><path d="M10 20v-5.5h4V20" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 3v2.2M12 18.8V21M3 12h2.2M18.8 12H21M5.6 5.6l1.6 1.6M16.8 16.8l1.6 1.6M18.4 5.6l-1.6 1.6M7.2 16.8l-1.6 1.6" /></>,
  package: <><path d="m12 3 8.5 4.5v9L12 21l-8.5-4.5v-9z" /><path d="m3.5 7.5 8.5 4.5 8.5-4.5M12 12v9" /></>,
  logout: <><path d="M9 4.5H5.5v15H9" /><path d="M14 8l4 4-4 4M8.5 12H18" /></>,
  trash: <><path d="M5 7h14M9 7V4.5h6V7M6.5 7l1 13h9l1-13" /><path d="M10.5 10.5v6M13.5 10.5v6" /></>,
  mail: <><path d="M3.5 6h17v12h-17z" /><path d="m4 6.8 8 6 8-6" /></>,
  calendar: <><path d="M4 5.5h16V20H4z" /><path d="M4 9.5h16M8 3.5v4M16 3.5v4" /></>,
  sparkle: <><path d="M12 3.5 13.7 9l5.5 1.7-5.5 1.7L12 18l-1.7-5.6L4.8 10.7 10.3 9z" /><path d="M18.5 16.5 19.3 19l2.2.8-2.2.7-.8 2.5-.7-2.5-2.3-.7 2.3-.8z" /></>,
  knife: <><path d="M4 20 15 9" /><path d="M13.5 4.5 20 11l-2 2-6.5-6.5z" /><path d="M4 20l-1 1M4 20l1-1" /></>,
  refresh: <><path d="M20 12a8 8 0 1 1-2.6-5.9" /><path d="M20 4v4.5h-4.5" /></>,
  gift: <><path d="M3.5 8.5h17V12h-17zM5 12h14v8H5z" /><path d="M12 8.5V20" /><path d="M12 8.5C10.5 8.5 8 7.6 8 5.9A2 2 0 0 1 12 5a2 2 0 0 1 4 .9c0 1.7-2.5 2.6-4 2.6Z" /></>,
  download: <><path d="M12 4v11" /><path d="m7.5 11 4.5 4.5L16.5 11" /><path d="M5 20h14" /></>,
} as const;

export type IconName = keyof typeof TRACES;

interface Props extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  filled?: boolean;
  strokeWidth?: number;
}

export function Icon({ name, size = 20, filled = false, strokeWidth = 1.6, className, ...rest }: Props) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false"
      fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={strokeWidth}
      strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
      {TRACES[name]}
    </svg>
  );
}

/** Cinq étoiles, remplies à la décimale près (une note de 4,8 se voit). */
export function Etoiles({ note, taille = 14, className }: { note: number; taille?: number; className?: string }) {
  return (
    <span className={className} role="img" aria-label={`${note.toFixed(1).replace('.', ',')} sur 5`}>
      <span className="inline-flex items-center gap-[2px]">
        {[0, 1, 2, 3, 4].map(i => {
          const plein = note - i >= 0.75;
          const demi = note - i >= 0.25 && note - i < 0.75;
          return (
            <span key={i} className="relative inline-flex">
              <Icon name="star" size={taille} className="text-linen-deep" strokeWidth={1.2} />
              {(plein || demi) && (
                <span className="absolute inset-0 overflow-hidden" style={{ width: plein ? '100%' : '50%' }}>
                  <Icon name="star" size={taille} filled className="text-laiton-600" strokeWidth={0} />
                </span>
              )}
            </span>
          );
        })}
      </span>
    </span>
  );
}
